import { stringify } from "csv/browser/esm/sync";
import { format, isValid } from "date-fns";
import fileDownload from "js-file-download";

import { InvoiceThreadDoc, ThreadStatus } from "@megaron/invoices-contracts";

import { InvoiceThreadFlat } from "./AllThreadsHome";
import { tableHeadingsList } from "./tableHeadingsListConstants";

const formatDateTime = (value: Date | null | undefined) => {
  if (!value || !isValid(value)) {
    return undefined;
  }

  return format(value, "yyyy-MM-dd, h:mm:ss");
};

const parseStatusName = (status: ThreadStatus) => {
  if (status === "open") {
    return "otwarty";
  }

  if (status === "approved") {
    return "zatwierdzony";
  }

  if (status === "closed") {
    return "odrzucony";
  }

  return undefined;
};

const mapInvoiceToCsvEntry = (invoice: InvoiceThreadDoc): InvoiceThreadFlat => ({
  referenceNumber: invoice.referenceNumber,
  title: invoice.title,
  decreeNumber: invoice.decreeNumber,
  approvedAt: formatDateTime(invoice.approvedAt),
  deadline: formatDateTime(invoice.deadline) ?? "",
  createdAt: formatDateTime(invoice.createdAt) ?? "",
  invoiceNumber: invoice.invoice.invoiceNumber,
  issuer: invoice.invoice.issuer,
  issueDate: formatDateTime(invoice.invoice.issueDate) ?? "",
  total: invoice.invoice.total.toNumber(),
  currency: invoice.invoice.currency,
  dueDate: formatDateTime(invoice.invoice.dueDate),
  status: parseStatusName(invoice.status),
  receivedDate: formatDateTime(invoice.invoice.receivedDate),
});

export const downloadInvoiceThreadsCsv = (threads: InvoiceThreadDoc[]) => {
  const entries = threads.map(mapInvoiceToCsvEntry);

  const columns = [
    ...tableHeadingsList.filter(({ key }) => key).map(({ key, label }) => ({ key: key as string, header: label })),
    { key: "total", header: "Kwota netto" },
    { key: "currency", header: "Waluta" },
    { key: "status", header: "Status" },
  ];

  const csv = stringify(entries, {
    header: true,
    columns,
  });

  fileDownload(csv, "faktury.csv");
};
